// Decisions for LevelUpOverlay, pulled out so the account-switching cases are tested.

export const ACKNOWLEDGED_LEVEL_KEY = 'novari_acknowledged_level';

/**
 * Per-account storage key. The key used to be device-wide, so on a shared
 * phone the previous student's level decided whether the next student ever saw
 * a level-up (a level-3 student behind a level-8 one never did).
 */
export function levelAckKey(userId: string): string {
    return `${ACKNOWLEDGED_LEVEL_KEY}:${userId}`;
}

export type LevelUpDecision = 'record-silently' | 'celebrate' | 'sync-silently' | 'none';

/**
 * `acknowledged` is 0 when this account has no record on this device yet.
 * `hydrated` is true once a real level for this account has been seen here.
 */
export function decideLevelUp(level: number, acknowledged: number, hydrated: boolean): LevelUpDecision {
    // First confirmed-real level for this account on this device: record it, never celebrate.
    if (level > 0 && acknowledged === 0) return 'record-silently';
    if (hydrated && level > acknowledged) return 'celebrate';
    // Level rose while the app was closed or loading: catch the record up without a fanfare.
    if (!hydrated && level > acknowledged) return 'sync-silently';
    return 'none';
}
